import { render, staticRenderFns } from "./Redirect.vue?vue&type=template&id=767d289e&scoped=true&"
import script from "./Redirect.vue?vue&type=script&lang=js&"
export * from "./Redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d289e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VContainer})
